var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container" }, [
    !_vm.$root.isMobile
      ? _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-12" },
            [
              _vm.title
                ? _c("div", { staticClass: "mb-40 d-flex flex-wrap w-100" }, [
                    _vm.title
                      ? _c("h3", {
                          staticClass: "title",
                          domProps: { innerHTML: _vm._s(_vm.title) }
                        })
                      : _vm._e()
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "slide-y-down-transition",
                {
                  staticClass: "static-content-row",
                  attrs: { group: "", tag: "div" }
                },
                _vm._l(_vm.staticItems, function(staticItem, index) {
                  return _c("static-card", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.show,
                        expression: "show"
                      }
                    ],
                    key: index,
                    ref: "cards",
                    refInFor: true,
                    staticClass: "static-card",
                    class: { "mb-40": _vm.moreItemsThanPossible },
                    style: {
                      width:
                        "calc(100% / " +
                        (index + 1 !== _vm.staticItems.length
                          ? _vm.item_count
                          : _vm.lastItemDivision) +
                        ")"
                    },
                    attrs: {
                      pages: _vm.pages,
                      "static-item": staticItem,
                      ratio: _vm.ratio,
                      "fixed-height":
                        index + 1 !== _vm.staticItems.length
                          ? null
                          : _vm.fixedHeight
                    }
                  })
                }),
                1
              )
            ],
            1
          )
        ])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.$root.isMobile,
            expression: "$root.isMobile"
          }
        ],
        staticClass: "row"
      },
      [
        _c("div", { staticClass: "col-12" }, [
          _c("h3", {
            staticClass: "title mb-32",
            domProps: { innerHTML: _vm._s(_vm.title) }
          }),
          _vm._v(" "),
          _c("div", { ref: "sliderParent", staticClass: "w-100" }, [
            _c(
              "div",
              { ref: "slider", staticClass: "static-content-slider" },
              _vm._l(_vm.staticItems, function(staticItem, index) {
                return _c("static-card", {
                  key: index,
                  staticClass: "static-card",
                  class: { "mb-40": _vm.moreItemsThanPossible },
                  attrs: {
                    pages: _vm.pages,
                    "static-item": staticItem,
                    ratio: _vm.mobileRatio
                  }
                })
              }),
              1
            )
          ])
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }